import apiClient from './client';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface UserData {
  id: string;
  name: string;
  email: string;
  role: string;
  profile: string;
  removedImage:boolean;
  createdAt: string;
  updatedAt: string;
}

export interface AuthResponse {
  message: string
  success: Boolean
  data: {
    user: {
      id: string;
      email: string;
      name: string;
      role: string;
    };
    token: string;
  }
}

export const authApi = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>('/auth/login', credentials);
    return response.data;
  },

  async logout(): Promise<{ success?: boolean, message: string }> {
    const response = await apiClient.post<{ success?: boolean, message: string }>('/auth/logout');
    return response.data;
  },

  async getCurrentUser(): Promise<{ success?: boolean, message: string,  data: UserData }> {
    const response = await apiClient.get<{ success?: boolean, message: string, data: UserData }>('/auth/me');
    return response.data;
  },

  async updateProfile(profile: FormData | UserData): Promise<{ success?: boolean, message: string, data: UserData }> {
    const config = profile instanceof FormData 
      ? { headers: { 'Content-Type': 'multipart/form-data' } } 
      : {};
    
    const response = await apiClient.patch<{ success?: boolean, message: string, data: UserData }>(
      '/auth/me', 
      profile,
      config
    );
    return response.data;
  },

  async refreshToken(): Promise<{ token: string }> {
    const response = await apiClient.post<{ token: string }>('/auth/refresh-token');
    return response.data;
  },

  async forgotPassword(email: string): Promise<{ success?: boolean, message: string }> {
    const response = await apiClient.post<{ message: string }>('/auth/forgot-password', { email });
    return response.data;
  },

  async resetPassword(token: string, newPassword: string, confirmPassword: string): Promise<{ success?: boolean, message: string }> {
    const response = await apiClient.patch<{ message: string }>('/auth/reset-password', {
      token,
      password: newPassword,
      confirmPassword: confirmPassword
    });
    return response.data;
  },
};
